<script lang="ts" setup>
import { useCurrentUser } from '@/composables/useCurrentUser'
import navItemsBase from '@/navigation/vertical'
import { filterNavForSuperAdmin } from '@/utils/navItems'
import { themeConfig } from '@themeConfig'
import { computed } from 'vue'

// Components
import AdminPanelMenu from '@/layouts/components/AdminPanelMenu.vue'
import ClientSelector from '@/layouts/components/ClientSelector.vue'
import Footer from '@/layouts/components/Footer.vue'
import Notifications from '@/layouts/components/Notifications.vue'
import SubscriptionBadge from '@/layouts/components/SubscriptionBadge.vue'
import UserProfile from '@/layouts/components/UserProfile.vue'
import NavBarI18n from '@core/components/I18n.vue'

// @layouts plugin
import { VerticalNavLayout } from '@layouts'

const { isAdmin, isSystemUser } = useCurrentUser()
const navItems = computed(() => filterNavForSuperAdmin(navItemsBase, isAdmin.value))

</script>

<template>
  <VerticalNavLayout :nav-items="navItems">
    <!-- 👉 navbar -->
    <template #navbar="{ toggleVerticalOverlayNavActive }">
      <div class="d-flex h-100 align-center navbar-content">
        <IconBtn
          id="vertical-nav-toggle-btn"
          class="ms-n3 d-lg-none"
          @click="toggleVerticalOverlayNavActive(true)"
        >
          <VIcon
            size="26"
            icon="tabler-menu-2"
          />
        </IconBtn>

        <VSpacer />

        <div class="d-flex align-center gap-2 navbar-actions">
          <AdminPanelMenu class="me-1" />
          <div class="d-none d-sm-block me-2 me-md-1">
            <ClientSelector />
          </div>
          <NavBarI18n
            v-if="themeConfig.app.i18n.enable && themeConfig.app.i18n.langConfig?.length"
            :languages="themeConfig.app.i18n.langConfig"
            class="d-none d-md-flex"
          />
          <SubscriptionBadge v-if="!isSystemUser" class="me-2" />
          <Notifications class="me-1 me-md-0" />
          <UserProfile />
        </div>
      </div>
    </template>

    <!-- 👉 Pages -->
    <slot />

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <!-- <TheCustomizer /> -->
  </VerticalNavLayout>
</template>
